import { APP_NAME } from 'app-config'

import { IRequestOptions, IResponseResult } from 'models/api.model'
import { IAppConfigResponseRaw, IPaymentConfigRaw } from 'models/config.model'

import { ApiService } from 'services/api.service'

import { RequestMethod } from 'root-constants'
import { TAppName } from 'root-types'

export class ConfigApi {
  private readonly appName: TAppName = APP_NAME
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getAppConfig(): Promise<IResponseResult<IAppConfigResponseRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
    }

    return this.api.makeRequest<IAppConfigResponseRaw>(
      `v1/flow/${this.appName}/config`,
      options,
    )
  }

  getPaymentConfig({
    cohort,
    uuid,
  }: {
    cohort: string
    uuid: string
  }): Promise<IResponseResult<IPaymentConfigRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { uuid },
    }

    return this.api.makeRequest<IPaymentConfigRaw>(
      `v1/flow/${this.appName}/variant/${cohort}/payment-config`,
      options,
    )
  }
}
